<!-- Иконка Saby по официальному знаку сервиса. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="20" cy="20" r="20" fill="#fff" stroke="none" />
    <g transform="translate(7 2) scale(.9)">
      <path
        d="M14.9022 22.922L6.83789 39.3599L24.2414 15.9999L23.469 13.2732L28.5927 6.23883L22.0664 8.31883L22.2269 8.88802L22.066 8.31989L19.7501 13.0403L0.931641 0.639038L14.9022 22.922Z"
        fill="#0C94FF"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "SabyIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
  },
};
</script>
